export enum MediaCategoryType {
  Main = "MAIN",
  Label = "LABEL"
}
